// src/Pages/RentalTerms/RentalTermsHelmetComponent.jsx
import { Helmet } from "react-helmet-async";

const RentalTermsHelmetComponent = () => {
  return (
    <Helmet>
      <title>Spiderlegs Productions | Vuokrausehdot</title>
      <meta
        name="description"
        content="Spiderlegs Productionsin vuokrausehdot koskien laitteiden ja peräkärryjen vuokrausta."
      />
      <meta name="robots" content="noindex" />

    </Helmet>
  );
};

export default RentalTermsHelmetComponent;
